import React from 'react';
import Loading, { LoadingBall } from '@ingka/loading';
import '@ingka/loading/dist/style.css';

const LoadingSpinner = () => {
  return (
    <Loading text="">
      <LoadingBall />
    </Loading>
  );
};

export default LoadingSpinner;
